module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/transaction-history/transaction-list/transaction-list.component.css
// module id = ./src/app/transaction-history/transaction-list/transaction-list.component.css
// module chunks = main